import { createSelector } from 'reselect';
import get from 'lodash/get';
import filter from 'lodash/filter';
import { initialState } from './reducer';
import { createSelectFieldOptions } from '../../utils/common';

const selectFestivalDomain = state => state.Festival || initialState;

const selectFestivalEntity = () => createSelector(selectFestivalDomain, subState => get(subState, 'festival'));
const selectFestivalContacts = () => createSelector(selectFestivalDomain, subState => get(subState, 'contacts.data'));

const selectFestivalContactsLoading = () =>
  createSelector(selectFestivalDomain, subState => get(subState, 'contacts.loading'));

const selectFestivalContactsUpdating = () =>
  createSelector(selectFestivalDomain, subState => get(subState, 'festivalContactsUpdating'));

const selectPerformancesList = () => createSelector(selectFestivalDomain, subState => get(subState, 'performances'));

const selectFestival = () => createSelector(selectFestivalEntity(), entity => get(entity, 'entity'));

const selectChosenFestivalPhotos = () =>
  createSelector(selectFestivalEntity(), subState => filter(get(subState, 'media'), { type: 'photo' }));

const selectChosenFestivalVideos = () =>
  createSelector(selectFestivalEntity(), subState => filter(get(subState, 'media'), { type: 'video' }));

const selectCompanies = () =>
  createSelector(selectFestivalDomain, subState =>
    createSelectFieldOptions(get(subState, 'companies.data', []), 'id', 'name'),
  );

const selectLoadingFieldName = () =>
  createSelector(selectFestivalDomain, subState => get(subState, 'loadingFieldName'));

const selectFestivalLoading = () => createSelector(selectFestivalEntity(), festival => get(festival, 'loading', false));

const selectFestivalDescriptions = () =>
  createSelector(selectFestivalDomain, festival => get(festival, 'descriptions', false));

const selectFestivalVenues = () =>
  createSelector(selectFestivalDomain, subState => {
    const festival = get(subState, 'festival.entity', {});
    const venues = get(subState, 'venues.data', []).map(v => ({
      ...v,
      isDefault: v.festivals?.find(c => c?.id === festival.id)?.isDefault,
    }));
    return { loading: get(subState, 'venues.loading', []), data: venues };
  });

const selectFestivalViewInitProductionsData = () =>
  createSelector(selectFestivalDomain, festival =>
    get(festival, 'viewInitialProductionsData', {
      data: {},
      query: {},
    }),
  );

export {
  selectFestivalDomain,
  selectFestival,
  selectChosenFestivalPhotos,
  selectChosenFestivalVideos,
  selectFestivalContacts,
  selectFestivalContactsUpdating,
  selectPerformancesList,
  selectCompanies,
  selectLoadingFieldName,
  selectFestivalLoading,
  selectFestivalDescriptions,
  selectFestivalContactsLoading,
  selectFestivalViewInitProductionsData,
  selectFestivalVenues,
};
